/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gen_Shipping_LabelInputs */

const en_gen_shipping_label = /** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gen Shipping Label`)
};

const es_gen_shipping_label = /** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar Etiqueta de Envío`)
};

const fr_gen_shipping_label = /** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer étiquette d'expédition`)
};

const de_gen_shipping_label = /** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versandetikett generieren`)
};

const id_gen_shipping_label = /** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Label Pengiriman`)
};

/** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */
const ja_gen_shipping_label = en_gen_shipping_label;

/** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */
const zh_gen_shipping_label = en_gen_shipping_label;

/** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */
const ar_gen_shipping_label = en_gen_shipping_label;

/** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */
const it_gen_shipping_label = en_gen_shipping_label;

/** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */
const ru_gen_shipping_label = en_gen_shipping_label;

/** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */
const pt_gen_shipping_label = en_gen_shipping_label;

/** @type {(inputs: Gen_Shipping_LabelInputs) => LocalizedString} */
const ko_gen_shipping_label = en_gen_shipping_label;

/**
* | output |
* | --- |
* | "Gen Shipping Label" |
*
* @param {Gen_Shipping_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gen_shipping_label = /** @type {((inputs?: Gen_Shipping_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gen_Shipping_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gen_shipping_label(inputs)
	if (locale === "es") return es_gen_shipping_label(inputs)
	if (locale === "fr") return fr_gen_shipping_label(inputs)
	if (locale === "de") return de_gen_shipping_label(inputs)
	if (locale === "ja") return ja_gen_shipping_label(inputs)
	if (locale === "zh") return zh_gen_shipping_label(inputs)
	if (locale === "ar") return ar_gen_shipping_label(inputs)
	if (locale === "id") return id_gen_shipping_label(inputs)
	if (locale === "it") return it_gen_shipping_label(inputs)
	if (locale === "ru") return ru_gen_shipping_label(inputs)
	if (locale === "pt") return pt_gen_shipping_label(inputs)
	return ko_gen_shipping_label(inputs)
});